/**
 * portalMeta — generated platform identity for the Portal v2 shell.
 * Generated by codaic portal_generator (DEC-063). Do not hand-edit.
 */

export const PORTAL_META = {
  platformName: 'gcos',
  platformTitle: 'GCManagementOS',
  platformShort: 'GC',
} as const;
